/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Week_Session_Calendar_Add_SessionInputs */

const fr_week_session_calendar_add_session = /** @type {(inputs: Week_Session_Calendar_Add_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter`)
};

/**

* @param {Week_Session_Calendar_Add_SessionInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const week_session_calendar_add_session = /** @type {((inputs?: Week_Session_Calendar_Add_SessionInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Week_Session_Calendar_Add_SessionInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_week_session_calendar_add_session(inputs)
});